import { addDays, differenceInDays } from 'date-fns';
import { useMemo } from 'react';

export const calculateUpcomingPaymentDays = (
  chargeDate: Date | undefined
): number => {
  return chargeDate
    ? differenceInDays(addDays(new Date(chargeDate), 1), new Date())
    : 0;
};

export const countUpcomingPaymentDays = (
  chargeDate: Date | undefined
): number => {
  return chargeDate
    ? differenceInDays(addDays(new Date(chargeDate), 1), new Date())
    : 0;
};

interface UseUpcomingPaymentDaysProps {
  chargeDate: Date | undefined;
}

interface UseUpcomingPaymentDaysResult {
  daysLeftToPayment: number;
}

export const useUpcomingPaymentDays = ({
  chargeDate,
}: UseUpcomingPaymentDaysProps): UseUpcomingPaymentDaysResult => {
  const daysLeftToPayment = useMemo(
    () => countUpcomingPaymentDays(chargeDate),
    [chargeDate]
  );

  return {
    daysLeftToPayment,
  };
};
